import Layout from "../Layout/Layout";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { getPages } from "./utilities/ApiCalls";
import firstimg from "../Images/1.png";
import "../css/about.css";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { setPageTitle } from "../utils/titleUtils";
import { Helmet } from "react-helmet-async";

export default function AboutUS() {
  const [about, setAbout] = useState({
    title: "About Us",
    content1: "Ilinke",
    content2: "Ilinke2",
  });
  const location = useLocation();

  useEffect(() => {
    setPageTitle("About Us");
  }, [location]);

  return (
    <Layout>
      <Helmet>
        <title>About Us | StoryTent</title>
        <meta name="description" content="Learn about StoryTent: our journey, who we are, what we do, and our mission to empower storytellers and poets worldwide." />
        <meta property="og:title" content="About Us | StoryTent" />
        <meta property="og:description" content="Learn about StoryTent: our journey, who we are, what we do, and our mission." />
        <meta property="og:url" content="https://www.storytent.in/about-us" />
        <link rel="canonical" href="https://www.storytent.in/about-us" />
      </Helmet>
      <Wrapper>
        <StyledSection className="about_section">
          <div className="container">
            <Divider />
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-md-6 col-12">
                <SectionCard>
                  <div className="mt-30">
                    <SectionTitle>{about.title}</SectionTitle>
                  </div>

                  <div className="about_info">
                    <BodyText>
                      Welcome to our visionary realm, crafted by the synergy of
                      artist Anusri Venkatesh, designer extraordinaire, and
                      poet. Fueled by the poignant realization that masterpieces
                      often languish in obscurity, Anusri embarked on a
                      transformative journey. Witnessing books of budding
                      creators struggle in a vast sea of unnoticed brilliance,
                      she joined forces to chart a journey for building and
                      growth of a community of wordsmiths beyond their
                      geographic boundaries. Together with her team, StoryTent
                      birthed a platform where the echoes of artistic tales find
                      resonance with their rightful audience.
                    </BodyText>
                    <BodyText>
                      Anusri’s commitment to bridging the gap between artists
                      and appreciators has garnered her the prestigious Times 40
                      Under 40 award, while her pioneering initiative has been
                      spotlighted in ET Newsmakers. Notably, she stands as the
                      official literature partner of BITS Pilani 2023, a
                      testament to her enduring dedication to unraveling the
                      narratives that deserve to shine.
                    </BodyText>
                  </div>
                  <MetricsRow className="row">
                    <div className="col-4 border-right">
                      <Metric>
                        <MetricValue>6400+</MetricValue>{" "}
                        <MetricLabel>Audience</MetricLabel>
                      </Metric>
                    </div>
                    <div className="col-4 border-right">
                      <Metric>
                        <MetricValue>500+</MetricValue>{" "}
                        <MetricLabel>Poems</MetricLabel>
                      </Metric>
                    </div>
                    <div className="col-4">
                      <Metric>
                        <MetricValue>300+</MetricValue>{" "}
                        <MetricLabel>Stories</MetricLabel>
                      </Metric>
                    </div>
                  </MetricsRow>
                </SectionCard>
              </div>
              <div className="col-lg-6 col-sm-6 col-md-6 col-12 d-flex justify-content-center align-items-center">
                <ImageFrame>
                  <img src={firstimg} className="img-fluid" alt="img" />
                </ImageFrame>
              </div>
            </div>
          </div>
        </StyledSection>

        <StyledSection className="about_section1">
          <div className="container">
            <SectionCard>
              <div className="row">
                <div className="mt-30">
                  <SectionTitle>Who We Are</SectionTitle>
                </div>

                <div className="col-lg-12 col-sm-12 col-md-12 col-12">
                  <Divider />

                  <div className="about_info">
                    <BodyText>
                      StoryTent was founded on the belief that artistic
                      brilliance resides within everyone. We are a passionate team
                      and community of creators, designers, poets, and storytellers
                      building a home where wordsmiths of all backgrounds find
                      encouragement, recognition, and an audience that truly
                      resonates with their voice. From debut poets to seasoned
                      authors, we unite diverse voices across English, Hindi,
                      and regional languages in a supportive, inclusive haven free
                      of gatekeeping.
                    </BodyText>
                  </div>
                </div>
              </div>
            </SectionCard>
          </div>
        </StyledSection>

        <StyledSection className="about_section1">
          <div className="container">
            <SectionCard>
              <div className="row">
                <div className="mt-30">
                  <SectionTitle>What We Do</SectionTitle>
                </div>

                <div className="col-lg-12 col-sm-12 col-md-12 col-12">
                  <Divider />

                  <div className="about_info">
                    <BodyText>
                      At StoryTent, we serve the realms of virtual and
                      in-reality creativity converge, fostering a vibrant
                      community bound by the love for storytelling. Through our
                      innovative online portal and the immersive offline open
                      mic events, our brand Koral, we provide a dynamic platform
                      for storytellers and readers alike to bridge the gap
                      between their artistic expression and recognition. Online,
                      our portal acts as a digital canvas, enabling storytellers
                      to weave their narratives and connect with a global
                      audience. Offline, Koral invites participants to share
                      their tales in a live setting, fostering genuine
                      connections in the shared experience of storytelling. We
                      are the architects of a community where creativity knows
                      no boundaries, and every artist’s longing for recognition
                      is met with open arms.
                    </BodyText>
                  </div>
                </div>
              </div>
            </SectionCard>
          </div>
        </StyledSection>

        <StyledSection className="about_section1">
          <div className="container">
            <SectionCard>
              <div className="row">
                <SectionTitle>Our Story Our Mission</SectionTitle>
                <div className="about_info col-lg-12 col-sm-12 col-md-12 col-12">
                  <BodyText>
                    Our mission at StoryTent is rooted in the belief that
                    recognition is the pinnacle achievement for every artist.
                    The art of storytelling, boundless and formless, resides
                    within each human being from birth. We aspire to empower
                    individuals to create and express their tales effortlessly,
                    eliminating the concern of going unnoticed. In our vision,
                    everyone is a creator and finding the right audience is akin
                    to discovering a soulmate-a profound connection we are
                    dedicated to fostering, creating the purest relationship
                    between storytellers and those who crave their narratives.
                  </BodyText>
                </div>

                <SectionTitle>Our Vision</SectionTitle>
                <div className="col-lg-12 col-sm-12 col-md-12 col-12">
                  <BodyText>
                    At StoryTent, our vision is to cultivate a worldwide
                    community of readers and writers, transcending borders and
                    embracing the boundless realm where storytelling knows no
                    constraints. We are already embarked on a resolute journey
                    to become pan-India, hosting open mics across the country
                    and featuring the national language, Hindi, in addition to
                    English, as a distinguished category for writing. Looking
                    ahead, our expansion plans encompass a diverse array of
                    regional languages, ensuring that every linguistic tapestry
                    finds its own vibrant community. Our ultimate goal is to
                    celebrate the richness of global expression, where every
                    soul, regardless of origin or language, can freely share
                    their stories and be cherished for their unique expression.
                  </BodyText>
                </div>
              </div>
            </SectionCard>
          </div>
        </StyledSection>
      </Wrapper>
    </Layout>
  );
}

const Wrapper = styled.div`
  background: transparent;
  color: var(--color-text);
  padding: 24px 0 40px;
  text-align: justify;
`;

const StyledSection = styled.section`
  background: transparent;
`;

const SectionCard = styled.div`
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: 20px 22px 26px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
`;

const SectionTitle = styled.h1`
  color: var(--color-text);
  margin-bottom: 10px;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--color-border);
  opacity: 0.65;
  margin: 10px 0 18px;
`;

const BodyText = styled.p`
  color: var(
    --color-text-tertiary,
    var(--color-text-secondary, var(--color-text))
  );
  margin-bottom: 14px;
  line-height: 1.7;
`;

const MetricsRow = styled.div`
  margin-top: 10px;

  .border-right {
    border-color: var(--color-border) !important;
  }
`;

const Metric = styled.div`
  color: var(--color-text);
  padding: 8px 0;
`;

const MetricValue = styled.h5`
  color: var(--color-text);
  margin-bottom: 4px;
`;

const MetricLabel = styled.p`
  color: var(--color-text-secondary, var(--color-text));
  margin: 0;
`;

const ImageFrame = styled.div`
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 10px;
  background: var(--color-surface);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
`;
